import { useMemo, useState, useEffect } from 'react';
import { ListRange } from 'react-virtuoso';
import { debounce } from 'lodash';
import { useCurrentUserId } from '@/utils';
import { useWindowVisible, useDebounceCallback } from '@/hooks';

import { TABS } from '../const';
import { FeedItem } from '../types';
import { fetchFeedsDetail } from './feed';

const EnableUpdateList = [TABS[0].mode, TABS[1].mode];

export const useUpdateStream = (
  currentMode: string,
  feeds: Record<string, FeedItem[] | undefined>,
) => {
  const isVisible = useWindowVisible();
  const currentAddress = useCurrentUserId();

  const [visibleRange, setVisibleRange] = useState<Record<string, ListRange>>({});

  const updateFeeds = useDebounceCallback((range?: ListRange) => {
    const _range = range || visibleRange[currentMode];

    if (_range && feeds[currentMode]?.length) {
      const { startIndex, endIndex } = _range;
      const visibleItems = (feeds[currentMode] || []).slice(startIndex, endIndex + 1);

      // hot 列表点击就刷新
      if (isVisible && EnableUpdateList?.includes(currentMode)) {
        fetchFeedsDetail(currentAddress, visibleItems);
      }
    }
  });

  const onRangeChanged = useMemo(
    () =>
      TABS.reduce(
        (m, { mode }) => {
          m[mode] = debounce((range: ListRange) => {
            if (EnableUpdateList?.includes(mode) && feeds[mode]?.length) {
              setVisibleRange(pre => ({
                ...pre,
                [mode]: range,
              }));

              updateFeeds(range);
            }
          }, 1000);

          return m;
        },
        {} as Record<string, (range: ListRange) => void>,
      ),
    [feeds, updateFeeds],
  );

  useEffect(() => {
    updateFeeds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, currentMode]);

  return {
    onRangeChanged,
    updateFeeds,
  };
};
